
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as legislationyToI0nbvwFVU9vlfqdFaVPtDDm2z2j8yt_hzuP2jQjYMeta } from "/opt/build/repo/app/pages/profile/signature-standards/update/legislation.vue?macro=true";
import { default as confirmsq8WSIRw22JvuXzNGocI0lqMqFxL1wVKE1g4NFSQky0Meta } from "/opt/build/repo/app/pages/signup/flows/eidplus/confirm.vue?macro=true";
import { default as newZe4tT2axV62HNojaTIMPX_Ug_tYH_fvk8aDyaQlfrVkMeta } from "/opt/build/repo/app/pages/signup/flows/eidplus/new.vue?macro=true";
import { default as plan0KgbBaiaCbfp6mAMBVyaecYl8RWUDNJWYf5jKBMzfaAMeta } from "/opt/build/repo/app/pages/business/billing/plan.vue?macro=true";
import { default as apiNCivkX5FwEE3ZsMh_oIFFqwtma9Vp8stWFLcBAKb0XcMeta } from "/opt/build/repo/app/pages/business/developers/api.vue?macro=true";
import { default as domainsgwL1XPp9qBWKrPsfnKPeGVVCZSRORmBJUwF2yo4sn2kMeta } from "/opt/build/repo/app/pages/business/members/domains.vue?macro=true";
import { default as groupsULayZmca2wuRRQu3WE1kCMOV7yD_J_rsHVKmmtdeUR8Meta } from "/opt/build/repo/app/pages/business/members/groups.vue?macro=true";
import { default as aes_45for_45businessBAjnyEzseK98A71nQQEFyLg_je_KA763Dub7hSsfr1QMeta } from "/opt/build/repo/app/pages/business/profile/aes-for-business.vue?macro=true";
import { default as mail_45sentW8D2Bu6k_7wMCIDaTx_4CjteYyF_B5Lhx1Gy3_FavAsMeta } from "/opt/build/repo/app/pages/business/signup/mail-sent.vue?macro=true";
import { default as stepsHiUmbBSbFHSgPJY202EAEKkzJ5GazI_5iEERX_uhsnQMeta } from "/opt/build/repo/app/pages/business/signup/steps.vue?macro=true";
import { default as login2hb9fi_bOfAkc9TZXzlC3uQSupSmjJJt_HUT_MUZrLwMeta } from "/opt/build/repo/app/pages/ph/oauth2/login.vue?macro=true";
import { default as indexMuG_T70wv3VoTRXXjZwN_X8cHaXhWKpLEo1s6MY0XwAMeta } from "/opt/build/repo/app/pages/profile/signature-standards/update/index.vue?macro=true";
import { default as companyHgvyf4ZIRCA9R85wY4FhmMEEPQYExEZ81qp3EWSXpscMeta } from "/opt/build/repo/app/pages/sso/error/company.vue?macro=true";
import { default as legislationObAsfxVXJBMwi9_fBlqwahHxIHZnmxEw1WDdgH4n8bQMeta } from "/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/legislation.vue?macro=true";
import { default as previewCBpuTlvR53JeNNyD0k4_Zk2eyK88rqrNLCqkw_o949oMeta } from "/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/preview.vue?macro=true";
import { default as indexZfupWTW7KBvY1zhCCTfGuLi6fr2mrUvxeRSjlT2m3oIMeta } from "/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/index.vue?macro=true";
import { default as index7BzX1IOzFNpSJsJUtfqYugSdaaKTtYC5Jsbe62K3qycMeta } from "/opt/build/repo/app/pages/business/seals/[sealName]/index.vue?macro=true";
import { default as activityVUS8uZEyWZMxXPhgOALDFICpRyoprxMcTn7eQB_E8kcMeta } from "/opt/build/repo/app/pages/business/activity.vue?macro=true";
import { default as dashboardJ3T2U0PgiGnRTFdb6nxyEUFBiBCAPZzmoJ8prCMe7K0Meta } from "/opt/build/repo/app/pages/business/dashboard.vue?macro=true";
import { default as documentKpOBroq9U7s6m1LcaZ_Edm1h9yS99PrcnaM6e_Qkxg8Meta } from "/opt/build/repo/app/pages/business/document.vue?macro=true";
import { default as emails34fwuq_oMUYhlqZtt5LGi2eubsyoI74kGq6_NPFQZ2cMeta } from "/opt/build/repo/app/pages/business/emails.vue?macro=true";
import { default as indexgvl5g57M3NFBQkiyCxNztwFfrrUagqP8_n_t3zDwXxoMeta } from "/opt/build/repo/app/pages/business/extras/index.vue?macro=true";
import { default as indextRkU_cWaAQlSTt45KsPG2MLMLZ5RNRiyHhNkhJX50p8Meta } from "/opt/build/repo/app/pages/business/members/index.vue?macro=true";
import { default as indexw4IWa45ipjAW3SaWL0kzaXyK78NN3GPZK_3mW5zaRAIMeta } from "/opt/build/repo/app/pages/business/profile/index.vue?macro=true";
import { default as indexWbj3wZ02VxZCWQDitX__ru0RgesC4IVK_XBQ_NcV0AUMeta } from "/opt/build/repo/app/pages/business/register/index.vue?macro=true";
import { default as indexV1M6kzLIL3M3SHpn2cHMqJwTZrqOgOUx4Ji8A9Knw9gMeta } from "/opt/build/repo/app/pages/business/seals/index.vue?macro=true";
import { default as indexYvrFF8XVI3RE04j2Xwo_EZevLK_6t_e20vH_oi0JC6UMeta } from "/opt/build/repo/app/pages/business/signup/index.vue?macro=true";
import { default as upgradeClR7O8hykucdQtPR5qwCESbrql8l_226YX7aadtRo5IMeta } from "/opt/build/repo/app/pages/business/upgrade.vue?macro=true";
import { default as welcome3DEtxOpiz1JJI1i0MCCgb1PFH6t9Bt4dpqHwZB2to8IMeta } from "/opt/build/repo/app/pages/business/welcome.vue?macro=true";
import { default as redirectIeE1E2zokKHQh3BKkKMT_Sq_QEYUKqIKj9hA_9u3klcMeta } from "/opt/build/repo/app/pages/mab/redirect.vue?macro=true";
import { default as redirect_45identE_Xc7T6VIYS2eqQeJBBZ2KL_mprBI3GkkVW47w_bkxoMeta } from "/opt/build/repo/app/pages/mab/redirect-ident.vue?macro=true";
import { default as confirmheg36Top685ympMo5uOCSdXG6YpeChSJjTs498Loo38Meta } from "/opt/build/repo/app/pages/password-reset/confirm.vue?macro=true";
import { default as mail_45sentZbd28q2g4sJSgSM6JsikMxR_XJkg0nbopY8I_eXplGgMeta } from "/opt/build/repo/app/pages/password-reset/mail-sent.vue?macro=true";
import { default as newoyO_bq7OWJtnLEQniuq5tuklrLR2jDrAHsLQ1yBaW6sMeta } from "/opt/build/repo/app/pages/password-reset/new.vue?macro=true";
import { default as change_45passwordenZjUyfuwJpCxSKQMvylNhQfXeN7KVnOj55WJdu_F4kMeta } from "/opt/build/repo/app/pages/profile/change-password.vue?macro=true";
import { default as confirmsS9QCP4R5CkO5WxAJcBFZBs4pjKFixvQDvun0rrEXeIMeta } from "/opt/build/repo/app/pages/profile/confirm.vue?macro=true";
import { default as settingsBxX1AxuNB28dCCbyTFxJOw4A_fw2IqKabaRngRcmRikMeta } from "/opt/build/repo/app/pages/profile/settings.vue?macro=true";
import { default as indexpLiDl4L4av2VAhYADnSeH2opWw3NtVhOMFU_uBh8mkgMeta } from "/opt/build/repo/app/pages/profile/signature-standards/index.vue?macro=true";
import { default as visual_45signatureqVSvJz_kInWA3aKa8hIVhrW1xMVcuQ_35763WH24AHoMeta } from "/opt/build/repo/app/pages/profile/visual-signature.vue?macro=true";
import { default as confirmJry98P_VM0DPt5a_XT6cGuyk8aPjxANxRm2qgg_5ZwoMeta } from "/opt/build/repo/app/pages/signup/confirm.vue?macro=true";
import { default as mail_45sent7dgsqxRfZQhOnTOufj0X1CjIOBU9NWeCk83wyqTktmIMeta } from "/opt/build/repo/app/pages/signup/mail-sent.vue?macro=true";
import { default as ssogiXhfx3iMSDDx7z8zWVdq3ybhLfdmK1nKnniC4JPmLAMeta } from "/opt/build/repo/app/pages/signup/sso.vue?macro=true";
import { default as indexfe6J_mFh6hx3kFfGkX9PLRa9Sq1ZnaLllEg9EW_uneoMeta } from "/opt/build/repo/app/pages/signup/starter/index.vue?macro=true";
import { default as stepsTr770LCZBHH3h4EG5VYw8Ib1dcoaThlRyyWmorXysI0Meta } from "/opt/build/repo/app/pages/signup/steps.vue?macro=true";
import { default as index_1UYHee7UtED68MIuZJr69jPhCeyw0zX7ljmAX6pWIwMeta } from "/opt/build/repo/app/pages/sso/error/index.vue?macro=true";
import { default as index9Ow7OD_W2ZH0BSZsY5dxEe2djjk2Qjqct8N9yQJXm0oMeta } from "/opt/build/repo/app/pages/starter/register/index.vue?macro=true";
import { default as indexr0lQSBiQ76EtSbfr3Ptef9uGdmvCqDwV6OYG_ISTEiYMeta } from "/opt/build/repo/app/pages/view/[id]/[userid]/index.vue?macro=true";
import { default as indexLxqCeELJOeq6EzTwG_YgxU6vX9sslS0zycrIc4OhunoMeta } from "/opt/build/repo/app/pages/invite/[id]/index.vue?macro=true";
import { default as index1qaNvTu3A_HP8ts7oZLrEsiUyaKMexnvKg9xAtF1asMMeta } from "/opt/build/repo/app/pages/sendto/[id]/index.vue?macro=true";
import { default as indexqv8ihZIyNPneEXKnvohRq7hHzt2SHHLkwXb0s_KC9QMMeta } from "/opt/build/repo/app/pages/view/[srid]/index.vue?macro=true";
import { default as account_45deactivated2t_oRDQ8N_c_0Wls78xconFp9epiJCTBY0_o3C2CPwwMeta } from "/opt/build/repo/app/pages/account-deactivated.vue?macro=true";
import { default as byeI6cUU8pEwe5huV_ricRsf5xPaqKJ1Y1jNYdd_jwhY8QMeta } from "/opt/build/repo/app/pages/bye.vue?macro=true";
import { default as cookiesblockedgFZn8u6wpNC_GYGlDamSV_Dnp8szwXwIR3Ylc_Y7SnkMeta } from "/opt/build/repo/app/pages/cookiesblocked.vue?macro=true";
import { default as declinedELdcUGzZ4DlnzhZf6zBICx_qeQHTMZQmK_ndwy7pWkgMeta } from "/opt/build/repo/app/pages/declined.vue?macro=true";
import { default as expired5kaGedNmgXromjDi9CoY8CnSauEwzws48Yq_adx_gDAMeta } from "/opt/build/repo/app/pages/expired.vue?macro=true";
import { default as loginqc2SZdlsIYiKJ9ria9ynkhNw7gUGiGR0aNMcDdoUShcMeta } from "/opt/build/repo/app/pages/login.vue?macro=true";
import { default as logoutmrYvlCUsIETsFgvDL6NGRSxO2xVInJuC_gAlnWrOmhEMeta } from "/opt/build/repo/app/pages/logout.vue?macro=true";
import { default as maintenance4YtAP7h_1VMQlN8zHBt0WwsmwthWffqr_65hW57bZX4Meta } from "/opt/build/repo/app/pages/maintenance.vue?macro=true";
import { default as not_45availablejzUCOhw2EzeBfE10S_nWTc9qiD_vcpFrcKOoORp2EIQMeta } from "/opt/build/repo/app/pages/not-available.vue?macro=true";
import { default as indexLNiZqQE1Zu_hFW75JY6sDbl826X9Y6UrUSn6RB6BFKgMeta } from "/opt/build/repo/app/pages/password-reset/index.vue?macro=true";
import { default as plan6N3h9EhgzckW6maa1_8MkH4ko_4OhNYavnVYkOAcxkQMeta } from "/opt/build/repo/app/pages/plan.vue?macro=true";
import { default as indexvk8yUe5tdBmtBeu_vc48zqvk6dJP7S7K6crrXCdiWJAMeta } from "/opt/build/repo/app/pages/profile/index.vue?macro=true";
import { default as signedyNNmU7xtedvxy8fnUd3oo9ux2x7tl8ZHjrCD1eQ65RYMeta } from "/opt/build/repo/app/pages/signed.vue?macro=true";
import { default as indexIg6IT1NnzBlq5IY65N_rEuarp3BBMS_evWRoBgGXrI8Meta } from "/opt/build/repo/app/pages/signup/index.vue?macro=true";
import { default as sorryyUS57_D0rnnDQz6bskHUFASX5_qw1JzncEmh8yn_AwAMeta } from "/opt/build/repo/app/pages/sorry.vue?macro=true";
import { default as upgradeMxYog7QLEMte5wuroQVqgBKNGVG5GmCEU0Y6k6b9mqAMeta } from "/opt/build/repo/app/pages/upgrade.vue?macro=true";
import { default as uploadVhyEir_M4I2VfwquRjCO6Jwru_iR901QccfLkG56LSUMeta } from "/opt/build/repo/app/pages/upload.vue?macro=true";
import { default as welcome1sxVynawILQJeOx68YIdz5YEplIrdtFlXmPwMDfjdPsMeta } from "/opt/build/repo/app/pages/welcome.vue?macro=true";
import { default as _91_46_46_46slug_93LUBYWIBMkwgjxeWLqiy2ewi_tIjdxvtv_hXH6_ECjWIMeta } from "/opt/build/repo/app/pages/[...slug].vue?macro=true";
import { default as indexcpcWNSbn9wmmk6rj_vIV3Lfs0pLXdg5oPT5xBB9CGloMeta } from "/opt/build/repo/app/pages/index.vue?macro=true";
export default [
  {
    name: "profile-signature-standards-legislation",
    path: "/profile/signature-standards/update/legislation",
    meta: legislationyToI0nbvwFVU9vlfqdFaVPtDDm2z2j8yt_hzuP2jQjYMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/signature-standards/update/legislation.vue")
  },
  {
    name: "signup-flows-eidplus-confirm",
    path: "/signup/flows/eidplus/confirm",
    meta: confirmsq8WSIRw22JvuXzNGocI0lqMqFxL1wVKE1g4NFSQky0Meta || {},
    component: () => import("/opt/build/repo/app/pages/signup/flows/eidplus/confirm.vue")
  },
  {
    name: "signup-flows-eidplus-new",
    path: "/signup/flows/eidplus/new",
    meta: newZe4tT2axV62HNojaTIMPX_Ug_tYH_fvk8aDyaQlfrVkMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/flows/eidplus/new.vue")
  },
  {
    name: "business-billing-plan",
    path: "/business/billing/plan",
    meta: plan0KgbBaiaCbfp6mAMBVyaecYl8RWUDNJWYf5jKBMzfaAMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/billing/plan.vue")
  },
  {
    name: "business-developers-api",
    path: "/business/developers/api",
    meta: apiNCivkX5FwEE3ZsMh_oIFFqwtma9Vp8stWFLcBAKb0XcMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/developers/api.vue")
  },
  {
    name: "business-members-domains",
    path: "/business/members/domains",
    meta: domainsgwL1XPp9qBWKrPsfnKPeGVVCZSRORmBJUwF2yo4sn2kMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/members/domains.vue")
  },
  {
    name: "business-members-groups",
    path: "/business/members/groups",
    meta: groupsULayZmca2wuRRQu3WE1kCMOV7yD_J_rsHVKmmtdeUR8Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/members/groups.vue")
  },
  {
    name: "business-profile-aes-for-business",
    path: "/business/profile/aes-for-business",
    meta: aes_45for_45businessBAjnyEzseK98A71nQQEFyLg_je_KA763Dub7hSsfr1QMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/profile/aes-for-business.vue")
  },
  {
    name: "business-signup-mail-sent",
    path: "/business/signup/mail-sent",
    meta: mail_45sentW8D2Bu6k_7wMCIDaTx_4CjteYyF_B5Lhx1Gy3_FavAsMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/signup/mail-sent.vue")
  },
  {
    name: "business-signup-steps",
    path: "/business/signup/steps",
    meta: stepsHiUmbBSbFHSgPJY202EAEKkzJ5GazI_5iEERX_uhsnQMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/signup/steps.vue")
  },
  {
    name: "ph-oauth2-login",
    path: "/ph/oauth2/login",
    meta: login2hb9fi_bOfAkc9TZXzlC3uQSupSmjJJt_HUT_MUZrLwMeta || {},
    component: () => import("/opt/build/repo/app/pages/ph/oauth2/login.vue")
  },
  {
    name: "profile-signature-standards-update",
    path: "/profile/signature-standards/update",
    meta: indexMuG_T70wv3VoTRXXjZwN_X8cHaXhWKpLEo1s6MY0XwAMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/signature-standards/update/index.vue")
  },
  {
    name: "sso-error-company",
    path: "/sso/error/company",
    meta: companyHgvyf4ZIRCA9R85wY4FhmMEEPQYExEZ81qp3EWSXpscMeta || {},
    component: () => import("/opt/build/repo/app/pages/sso/error/company.vue")
  },
  {
    name: "direct-sign-identification-legislation",
    path: "/direct-sign/identification/:id()/:userid()/legislation",
    meta: legislationObAsfxVXJBMwi9_fBlqwahHxIHZnmxEw1WDdgH4n8bQMeta || {},
    component: () => import("/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/legislation.vue")
  },
  {
    name: "direct-sign-identification-id-userid-preview",
    path: "/direct-sign/identification/:id()/:userid()/preview",
    meta: previewCBpuTlvR53JeNNyD0k4_Zk2eyK88rqrNLCqkw_o949oMeta || {},
    component: () => import("/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/preview.vue")
  },
  {
    name: "direct-sign-identification",
    path: "/direct-sign/identification/:id()/:userid()",
    meta: indexZfupWTW7KBvY1zhCCTfGuLi6fr2mrUvxeRSjlT2m3oIMeta || {},
    component: () => import("/opt/build/repo/app/pages/direct-sign/identification/[id]/[userid]/index.vue")
  },
  {
    name: "business-seals-sealName",
    path: "/business/seals/:sealName()",
    meta: index7BzX1IOzFNpSJsJUtfqYugSdaaKTtYC5Jsbe62K3qycMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/seals/[sealName]/index.vue")
  },
  {
    name: "business-activity",
    path: "/business/activity",
    meta: activityVUS8uZEyWZMxXPhgOALDFICpRyoprxMcTn7eQB_E8kcMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/activity.vue")
  },
  {
    name: "business-dashboard",
    path: "/business/dashboard",
    meta: dashboardJ3T2U0PgiGnRTFdb6nxyEUFBiBCAPZzmoJ8prCMe7K0Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/dashboard.vue")
  },
  {
    name: "business-document",
    path: "/business/document",
    meta: documentKpOBroq9U7s6m1LcaZ_Edm1h9yS99PrcnaM6e_Qkxg8Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/document.vue")
  },
  {
    name: "business-emails",
    path: "/business/emails",
    meta: emails34fwuq_oMUYhlqZtt5LGi2eubsyoI74kGq6_NPFQZ2cMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/emails.vue")
  },
  {
    name: "business-extras",
    path: "/business/extras",
    meta: indexgvl5g57M3NFBQkiyCxNztwFfrrUagqP8_n_t3zDwXxoMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/extras/index.vue")
  },
  {
    name: "business-members",
    path: "/business/members",
    meta: indextRkU_cWaAQlSTt45KsPG2MLMLZ5RNRiyHhNkhJX50p8Meta || {},
    component: () => import("/opt/build/repo/app/pages/business/members/index.vue")
  },
  {
    name: "business-profile",
    path: "/business/profile",
    meta: indexw4IWa45ipjAW3SaWL0kzaXyK78NN3GPZK_3mW5zaRAIMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/profile/index.vue")
  },
  {
    name: "business-register",
    path: "/business/register",
    meta: indexWbj3wZ02VxZCWQDitX__ru0RgesC4IVK_XBQ_NcV0AUMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/register/index.vue")
  },
  {
    name: "business-seals",
    path: "/business/seals",
    meta: indexV1M6kzLIL3M3SHpn2cHMqJwTZrqOgOUx4Ji8A9Knw9gMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/seals/index.vue")
  },
  {
    name: "business-signup",
    path: "/business/signup",
    meta: indexYvrFF8XVI3RE04j2Xwo_EZevLK_6t_e20vH_oi0JC6UMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/signup/index.vue")
  },
  {
    name: "business-upgrade",
    path: "/business/upgrade",
    meta: upgradeClR7O8hykucdQtPR5qwCESbrql8l_226YX7aadtRo5IMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/upgrade.vue")
  },
  {
    name: "business-welcome",
    path: "/business/welcome",
    meta: welcome3DEtxOpiz1JJI1i0MCCgb1PFH6t9Bt4dpqHwZB2to8IMeta || {},
    component: () => import("/opt/build/repo/app/pages/business/welcome.vue")
  },
  {
    name: "mab-redirect",
    path: "/mab/redirect",
    meta: redirectIeE1E2zokKHQh3BKkKMT_Sq_QEYUKqIKj9hA_9u3klcMeta || {},
    component: () => import("/opt/build/repo/app/pages/mab/redirect.vue")
  },
  {
    name: "mab-redirect-ident",
    path: "/mab/redirect-ident",
    meta: redirect_45identE_Xc7T6VIYS2eqQeJBBZ2KL_mprBI3GkkVW47w_bkxoMeta || {},
    component: () => import("/opt/build/repo/app/pages/mab/redirect-ident.vue")
  },
  {
    name: "password-reset-confirm",
    path: "/password-reset/confirm",
    meta: confirmheg36Top685ympMo5uOCSdXG6YpeChSJjTs498Loo38Meta || {},
    component: () => import("/opt/build/repo/app/pages/password-reset/confirm.vue")
  },
  {
    name: "password-reset-mail-sent",
    path: "/password-reset/mail-sent",
    meta: mail_45sentZbd28q2g4sJSgSM6JsikMxR_XJkg0nbopY8I_eXplGgMeta || {},
    component: () => import("/opt/build/repo/app/pages/password-reset/mail-sent.vue")
  },
  {
    name: "password-reset-new",
    path: "/password-reset/new",
    meta: newoyO_bq7OWJtnLEQniuq5tuklrLR2jDrAHsLQ1yBaW6sMeta || {},
    component: () => import("/opt/build/repo/app/pages/password-reset/new.vue")
  },
  {
    name: "profile-change-password",
    path: "/profile/change-password",
    meta: change_45passwordenZjUyfuwJpCxSKQMvylNhQfXeN7KVnOj55WJdu_F4kMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/change-password.vue")
  },
  {
    name: "profile-confirm",
    path: "/profile/confirm",
    meta: confirmsS9QCP4R5CkO5WxAJcBFZBs4pjKFixvQDvun0rrEXeIMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/confirm.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsBxX1AxuNB28dCCbyTFxJOw4A_fw2IqKabaRngRcmRikMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/settings.vue")
  },
  {
    name: "profile-signature-standards",
    path: "/profile/signature-standards",
    meta: indexpLiDl4L4av2VAhYADnSeH2opWw3NtVhOMFU_uBh8mkgMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/signature-standards/index.vue")
  },
  {
    name: "profile-visual-signature",
    path: "/profile/visual-signature",
    meta: visual_45signatureqVSvJz_kInWA3aKa8hIVhrW1xMVcuQ_35763WH24AHoMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/visual-signature.vue")
  },
  {
    name: "signup-confirm",
    path: "/signup/confirm",
    meta: confirmJry98P_VM0DPt5a_XT6cGuyk8aPjxANxRm2qgg_5ZwoMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/confirm.vue")
  },
  {
    name: "signup-mail-sent",
    path: "/signup/mail-sent",
    meta: mail_45sent7dgsqxRfZQhOnTOufj0X1CjIOBU9NWeCk83wyqTktmIMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/mail-sent.vue")
  },
  {
    name: "signup-sso",
    path: "/signup/sso",
    meta: ssogiXhfx3iMSDDx7z8zWVdq3ybhLfdmK1nKnniC4JPmLAMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/sso.vue")
  },
  {
    name: "signup-starter",
    path: "/signup/starter",
    meta: indexfe6J_mFh6hx3kFfGkX9PLRa9Sq1ZnaLllEg9EW_uneoMeta || {},
    component: () => import("/opt/build/repo/app/pages/signup/starter/index.vue")
  },
  {
    name: "signup-steps",
    path: "/signup/steps",
    meta: stepsTr770LCZBHH3h4EG5VYw8Ib1dcoaThlRyyWmorXysI0Meta || {},
    component: () => import("/opt/build/repo/app/pages/signup/steps.vue")
  },
  {
    name: "sso-error",
    path: "/sso/error",
    meta: index_1UYHee7UtED68MIuZJr69jPhCeyw0zX7ljmAX6pWIwMeta || {},
    component: () => import("/opt/build/repo/app/pages/sso/error/index.vue")
  },
  {
    name: "starter-register",
    path: "/starter/register",
    meta: index9Ow7OD_W2ZH0BSZsY5dxEe2djjk2Qjqct8N9yQJXm0oMeta || {},
    component: () => import("/opt/build/repo/app/pages/starter/register/index.vue")
  },
  {
    name: "view-id-userid",
    path: "/view/:id()/:userid()",
    meta: indexr0lQSBiQ76EtSbfr3Ptef9uGdmvCqDwV6OYG_ISTEiYMeta || {},
    component: () => import("/opt/build/repo/app/pages/view/[id]/[userid]/index.vue")
  },
  {
    name: "invite-id",
    path: "/invite/:id()",
    meta: indexLxqCeELJOeq6EzTwG_YgxU6vX9sslS0zycrIc4OhunoMeta || {},
    component: () => import("/opt/build/repo/app/pages/invite/[id]/index.vue")
  },
  {
    name: "sendto-id",
    path: "/sendto/:id()",
    meta: index1qaNvTu3A_HP8ts7oZLrEsiUyaKMexnvKg9xAtF1asMMeta || {},
    component: () => import("/opt/build/repo/app/pages/sendto/[id]/index.vue")
  },
  {
    name: "view-srid",
    path: "/view/:srid()",
    meta: indexqv8ihZIyNPneEXKnvohRq7hHzt2SHHLkwXb0s_KC9QMMeta || {},
    component: () => import("/opt/build/repo/app/pages/view/[srid]/index.vue")
  },
  {
    name: "account-deactivated",
    path: "/account-deactivated",
    meta: account_45deactivated2t_oRDQ8N_c_0Wls78xconFp9epiJCTBY0_o3C2CPwwMeta || {},
    component: () => import("/opt/build/repo/app/pages/account-deactivated.vue")
  },
  {
    name: "bye",
    path: "/bye",
    meta: byeI6cUU8pEwe5huV_ricRsf5xPaqKJ1Y1jNYdd_jwhY8QMeta || {},
    component: () => import("/opt/build/repo/app/pages/bye.vue")
  },
  {
    name: "cookiesblocked",
    path: "/cookiesblocked",
    meta: cookiesblockedgFZn8u6wpNC_GYGlDamSV_Dnp8szwXwIR3Ylc_Y7SnkMeta || {},
    component: () => import("/opt/build/repo/app/pages/cookiesblocked.vue")
  },
  {
    name: "declined",
    path: "/declined",
    meta: declinedELdcUGzZ4DlnzhZf6zBICx_qeQHTMZQmK_ndwy7pWkgMeta || {},
    component: () => import("/opt/build/repo/app/pages/declined.vue")
  },
  {
    name: "expired",
    path: "/expired",
    meta: expired5kaGedNmgXromjDi9CoY8CnSauEwzws48Yq_adx_gDAMeta || {},
    component: () => import("/opt/build/repo/app/pages/expired.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginqc2SZdlsIYiKJ9ria9ynkhNw7gUGiGR0aNMcDdoUShcMeta || {},
    component: () => import("/opt/build/repo/app/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutmrYvlCUsIETsFgvDL6NGRSxO2xVInJuC_gAlnWrOmhEMeta || {},
    component: () => import("/opt/build/repo/app/pages/logout.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenance4YtAP7h_1VMQlN8zHBt0WwsmwthWffqr_65hW57bZX4Meta || {},
    component: () => import("/opt/build/repo/app/pages/maintenance.vue")
  },
  {
    name: "not-available",
    path: "/not-available",
    meta: not_45availablejzUCOhw2EzeBfE10S_nWTc9qiD_vcpFrcKOoORp2EIQMeta || {},
    component: () => import("/opt/build/repo/app/pages/not-available.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexLNiZqQE1Zu_hFW75JY6sDbl826X9Y6UrUSn6RB6BFKgMeta || {},
    component: () => import("/opt/build/repo/app/pages/password-reset/index.vue")
  },
  {
    name: "plan",
    path: "/plan",
    meta: plan6N3h9EhgzckW6maa1_8MkH4ko_4OhNYavnVYkOAcxkQMeta || {},
    component: () => import("/opt/build/repo/app/pages/plan.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexvk8yUe5tdBmtBeu_vc48zqvk6dJP7S7K6crrXCdiWJAMeta || {},
    component: () => import("/opt/build/repo/app/pages/profile/index.vue")
  },
  {
    name: "signed",
    path: "/signed",
    meta: signedyNNmU7xtedvxy8fnUd3oo9ux2x7tl8ZHjrCD1eQ65RYMeta || {},
    component: () => import("/opt/build/repo/app/pages/signed.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexIg6IT1NnzBlq5IY65N_rEuarp3BBMS_evWRoBgGXrI8Meta || {},
    component: () => import("/opt/build/repo/app/pages/signup/index.vue")
  },
  {
    name: "sorry",
    path: "/sorry",
    meta: sorryyUS57_D0rnnDQz6bskHUFASX5_qw1JzncEmh8yn_AwAMeta || {},
    component: () => import("/opt/build/repo/app/pages/sorry.vue")
  },
  {
    name: "upgrade",
    path: "/upgrade",
    meta: upgradeMxYog7QLEMte5wuroQVqgBKNGVG5GmCEU0Y6k6b9mqAMeta || {},
    component: () => import("/opt/build/repo/app/pages/upgrade.vue")
  },
  {
    name: "upload",
    path: "/upload",
    meta: uploadVhyEir_M4I2VfwquRjCO6Jwru_iR901QccfLkG56LSUMeta || {},
    component: () => import("/opt/build/repo/app/pages/upload.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcome1sxVynawILQJeOx68YIdz5YEplIrdtFlXmPwMDfjdPsMeta || {},
    component: () => import("/opt/build/repo/app/pages/welcome.vue")
  },
  {
    name: "404",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93LUBYWIBMkwgjxeWLqiy2ewi_tIjdxvtv_hXH6_ECjWIMeta || {},
    component: () => import("/opt/build/repo/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/dashboard",
    meta: indexcpcWNSbn9wmmk6rj_vIV3Lfs0pLXdg5oPT5xBB9CGloMeta || {},
    alias: ["/"],
    component: () => import("/opt/build/repo/app/pages/index.vue")
  }
]